function AdminPermissao() {
    return (
        <div>Admin dashboard</div>
    )
}

export default AdminPermissao